import { useState } from "react";
import CustomBlockButton from "../../../../../components/button/CustomBlockButton";
import { CustomDialog } from "../../../../../components/dialog/v1/CustomDialog";
import * as St from './index.styled';

export function WegetEditLocationTypeModal({
    open,
    onClose,
    selectedRackLocations,
    onUpdateRackLocations
}) {
    const [type, setType] = useState('NORMAL');

    const handleSubmit = () => {
        const newRackLocations = selectedRackLocations?.map(r => {
            return { ...r, type: type }
        });

        onUpdateRackLocations(newRackLocations);
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
            >
                <St.Header>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>로케이션 타입 일괄 변경</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </St.Header>
                <St.Body>
                    <div className='typeButtons'>
                        <CustomBlockButton
                            type='button'
                            className={`${type === 'NORMAL' ? 'selected' : ''}`}
                            onClick={() => setType('NORMAL')}
                        >NORMAL</CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className={`${type === 'INVENTORY' ? 'selected' : ''}`}
                            onClick={() => setType('INVENTORY')}
                        >INVENTORY</CustomBlockButton>
                    </div>
                    <div className='footerButtons'>
                        <CustomBlockButton
                            type='button'
                            onClick={() => onClose()}
                        >
                            취소
                        </CustomBlockButton>
                        <CustomBlockButton
                            type='button'
                            className='confirm'
                            onClick={() => handleSubmit()}
                        >
                            변경
                        </CustomBlockButton>
                    </div>
                </St.Body>
            </CustomDialog>
        </>
    );
}